import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiMissionsService } from '../../../../services/missions/api/api-missions.service';
import { AlertsService } from '../../../../services/alerts.service';
import { MissionReward } from '../../../../models/missions/mission-reward.model';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';

@Component({
  selector: 'app-mission-reward-edit-modal',
  templateUrl: './mission-reward-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class MissionRewardEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  missionRewardId: number = 0;
  startDate: string = '';
  endDate: string = '';
  currencyType: number = 0;
  currencyQuantity: number = 0;
  currencyTicketCost: number = 0;
  pointsRequired: number = 0;
  pointsRequiredTotal: number = 0;

  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];
  readonly UserCurrencyType = UserCurrencyType;

  private callbackSaved?: () => void;

  constructor(private apiMissionsService: ApiMissionsService, private alertsService: AlertsService) {}

  show(reward: MissionReward, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.missionRewardId = reward.missionRewardId;
    this.startDate = reward.startDateTimestamp ? this.timestampToDateString(reward.startDateTimestamp) : '';
    this.endDate = reward.endDateTimestamp ? this.timestampToDateString(reward.endDateTimestamp) : '';
    this.currencyType = reward.currencyType;
    this.currencyQuantity = reward.currencyQuantity;
    this.currencyTicketCost = reward.currencyTicketCost;
    this.pointsRequired = reward.pointsRequired;
    this.pointsRequiredTotal = reward.pointsRequiredTotal;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    const startTimestamp = this.startDate ? Math.floor(new Date(this.startDate + 'Z').getTime() / 1000) : 0;
    const endTimestamp = this.endDate ? Math.floor(new Date(this.endDate + 'Z').getTime() / 1000) : 0;
    const ticketCost = this.currencyType === UserCurrencyType.MatchTicket ? this.currencyTicketCost : 0;
    this.apiMissionsService.editMissionReward(this.missionRewardId, startTimestamp, endTimestamp, this.currencyType, this.currencyQuantity, ticketCost, this.pointsRequired, this.pointsRequiredTotal).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Mission reward updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating mission reward : ' + error);
      }
    );
  }

  private timestampToDateString(timestamp: number): string {
    const d = new Date(timestamp * 1000);
    const month = (d.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = d.getUTCDate().toString().padStart(2, '0');
    const hours = d.getUTCHours().toString().padStart(2, '0');
    const minutes = d.getUTCMinutes().toString().padStart(2, '0');
    return `${d.getUTCFullYear()}-${month}-${day}T${hours}:${minutes}`;
  }
}
